import { render, staticRenderFns } from "./PageOne.vue?vue&type=template&id=5074f25f&scoped=true&"
import script from "./PageOne.vue?vue&type=script&lang=ts&"
export * from "./PageOne.vue?vue&type=script&lang=ts&"
import style0 from "./PageOne.vue?vue&type=style&index=0&id=5074f25f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074f25f",
  null
  
)

export default component.exports